module.exports = __webpack_public_path__ + "media/icons/link-fb@3x-d9874d5b.svg";